<template>
  <div class="standard-page">
    <div class="detail-view-header">
      User Detail
    </div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <LabeledInfo label="First Name" :value="user.first_name" />
        <LabeledInfo label="Last Name" :value="user.last_name" />
        <LabeledInfo label="Email" :value="user.email" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="user.id" />
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'

export default {
  data() {
    return {
      user: {}
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.axios
        .get(endpoints.retrieveUser(this.$route.params.userID))
        .then(res => {
          this.user = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>
